import UserConst from "../presentation/components/const/UserConst";

export const getBadgeText = (notificationCount: number): string => {
  if (notificationCount > UserConst.DISP_NOTIFICATION_NUM_MAX) {
    return `${UserConst.DISP_NOTIFICATION_NUM_MAX}+`;
  }
  return String(notificationCount);
};
